/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBillingTerminatedVsTotalCountsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IBillingTerminatedVsTotalCountsQuery = {
  __typename?: 'Query';
  terminatedSoftwareEscrows: { __typename?: 'SoftwareEscrowPage'; nodesCount: number };
  allSoftwareEscrows: { __typename?: 'SoftwareEscrowPage'; nodesCount: number };
  removedBackups: { __typename?: 'BackupPage'; nodesCount: number };
  allBackups: { __typename?: 'BackupPage'; nodesCount: number };
  allContinuityEscrows: { __typename?: 'ContinuityEscrowPage'; nodesCount: number };
  terminatedContinuityEscrows: { __typename?: 'ContinuityEscrowPage'; nodesCount: number };
  allCustodianProfiles: { __typename?: 'CustodianProfilePage'; nodesCount: number };
  terminatedCustodianProfiles: { __typename?: 'CustodianProfilePage'; nodesCount: number };
  allSaasEscrows: { __typename?: 'SaasEscrowPage'; nodesCount: number };
  terminatedSaasEscrows: { __typename?: 'SaasEscrowPage'; nodesCount: number };
};

export const BillingTerminatedVsTotalCountsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'billingTerminatedVsTotalCounts' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'terminatedSoftwareEscrows' },
            name: { kind: 'Name', value: 'softwareEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'terminated' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allSoftwareEscrows' },
            name: { kind: 'Name', value: 'softwareEscrows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'removedBackups' },
            name: { kind: 'Name', value: 'backups' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'terminated' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allBackups' },
            name: { kind: 'Name', value: 'backups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allContinuityEscrows' },
            name: { kind: 'Name', value: 'continuityEscrows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'terminatedContinuityEscrows' },
            name: { kind: 'Name', value: 'continuityEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'terminated' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allCustodianProfiles' },
            name: { kind: 'Name', value: 'custodianProfiles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'terminatedCustodianProfiles' },
            name: { kind: 'Name', value: 'custodianProfiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'terminated' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'allSaasEscrows' },
            name: { kind: 'Name', value: 'saasEscrows' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'terminatedSaasEscrows' },
            name: { kind: 'Name', value: 'saasEscrows' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'terminated' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBillingTerminatedVsTotalCountsQuery, IBillingTerminatedVsTotalCountsQueryVariables>;
